import { ElementarSB } from '@ps20/bff-models';
import {
  convertBffZuersZoneIdtoZuersZoneEnum,
  ElementarSelbstbehalt,
} from '@ps20-frontend/frontend-models';

export function convertElementarSBToElementarSelbstbehalt(
  elementarSB: ElementarSB,
): ElementarSelbstbehalt {
  return {
    description: elementarSB.description,
    id: convertBffZuersZoneIdtoZuersZoneEnum(elementarSB.id),
  };
}
